// DeepLinkPage.js

import React, { useState } from "react";
import { useParams } from "react-router-dom";
import "./Landing.css"; // Assuming that this is where all your styles are defined

import { Helmet } from "react-helmet";

const DeepLinkCheck = () => {
  const { id } = useParams(); // Assuming your route is defined as '/c/:id'

  const handleOpenApp = () => {
    const deepLinkUrl = `outfitcheck:///check?id=${id}`;
    window.location.href = deepLinkUrl;
  };

  //isLoading
  const [isLoading, setIsLoading] = useState(false);

  const openCustomUrl = () => {
    //set loading
    setIsLoading(true);
    const deepLinkUrl = `outfitcheck:///check?id=${id}`;

    // const customUrl = "ultrachat:///character?id=27282863";
    const isMobileDevice =
      /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );

    if (isMobileDevice) {
      // Attempt to open the custom URL
      window.location.href = deepLinkUrl;

      // Wait for 2 seconds to check if the app opened
      setTimeout(() => {
        // Check if the user is still on your page after the timeout
        if (!document.hidden) {
          // Redirect to the appropriate app store
          if (/Android/i.test(navigator.userAgent)) {
            window.location.href =
              "https://play.google.com/store/apps/details?id=com.fashiongenie.fashiongenie&hl=en_US";
          } else if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
            window.location.href =
              "https://apps.apple.com/us/app/outfit-check-ai-style-scanner/id6476243809";
          }
        }

        setIsLoading(false);
      }, 2000); // 2 seconds timeout
    } else {
      // For non-mobile devices, redirect to a fallback URL
      window.location.href = "https://outfitcheck.app/";
    }
  };

  return (
    <main
      style={{
        backgroundColor: "#08d49c",
        height: "100%",
        textAlign: "center",
      }}
    >
      {/* ... other shared elements, such as alerts, if needed */}

      <Helmet defer={true}>
        <title>I sent you an OutfitCheck!</title>
        {/* ... other helmet data as in Landing component */}
      </Helmet>

      <section className="slider-area slider-bg2 second-slider-bg d-flex fix">
        {/* ... stars background and other elements if needed */}
        <div
          className="container action-space"
          style={{
            paddingRight: "40px",
            paddingLeft: "40px",
          }}
        >
          <div className="row">
            <div className="col-lg-12">
              <div className="slider-content second-slider-content text-center">
                {/* ... slogan and subslogan if needed */}
                <h3
                  style={{
                    color: "#005f45",
                    marginTop: "40px",
                    paddingTop: "100px",
                    fontSize: "28px",
                    overflowWrap: "break-word",
                  }}
                >
                  Check this outfit combo 👇
                </h3>
              </div>
            </div>
          </div>

          {/* The button for opening the app */}
          <div className="row">
            <div className="col-lg-12">
              <div className="slider-content text-center">
                <button onClick={openCustomUrl} className="open-in-app-button">
                  {isLoading ? "Loading..." : "Open in Outfit Check App"}
                </button>
              </div>
            </div>
          </div>

          {/* If you want to include links to Play Store or App Store from the original component, you can add them here */}
        </div>
      </section>
    </main>
  );
};

export default DeepLinkCheck;
